export default[
    {
        path: "/login-by-query/:authinfo/:redirecturl",
        name: "LoginByQuery",
        props: true,
        component: () => import(/* webpackChunkName: "common" */"../views/User/LoginByQuery/Index.vue"),
        meta: {
            title: "",
            showloading: true,
            requiresAuth: false
        }
    },
    {
        path: "/externallink",
        name: "_externallink",
        component:()=>import("../views/Externallink/index"),
        children: [
            {
                path: ":ec_id?",
                name: "externallinkconfig",
                props:true,
                component: () => import(/* webpackChunkName: "externallink" */"../views/Externallink/Index/Index.vue"),
                meta: {
                    title: "汇总",
                    showloading: false,
                    requiresAuth: true
                }
            },
        ]
    }
];
